import React from "react"
import { concatStrings, categoryIconMapping, getCategoryIconType } from "../utilities"
import DfbHeadline from "../ui-kit/dfb_headline"
import DfbAnchor from "../ui-kit/dfb_anchor"
import DfbIcon from "../ui-kit/dfb_icon"
import DfbParagraph from "../ui-kit/dfb_paragraph"
import DfbImage from "../ui-kit/dfb_image";

const CTeaserExternal = props => {
  const type = props.data.media_type
  const categories = props.data.categories
  const img = props.data.teaser_image
  const topline = props.data.kicker
  const headline = props.data.headline
  const description = props.data.text
  const link = props.data.link
  const link_obj = props.data.link_obj
  const overlay = props.data.overlay

  const iconTypes = (categories || []).map((item) => getCategoryIconType(item))
      .filter(itemType => itemType && categoryIconMapping(itemType) !== false)

  return (
    <div className={concatStrings("c-TeaserExternal", props.add_class)}>
      <a className="c-TeaserExternal-link" href={link_obj.url} target={link_obj.target}>
        {img.src && ["jpg", "jpeg", "png", "gif"].includes(img.extension) && (
          <div className="c-TeaserExternal-image">
            <div className="c-TeaserExternal-ratio">
              {!!overlay && (
                <div className="c-TeaserExternal-overlay" />
              )}

              <DfbImage
                image={img}
                lazyload={false}
              />

              {type && (
                <DfbIcon icon_type={type} viewBox="0 0 24 24" add_class="c-TeaserExternal-icon c-TeaserExternal-icon--type" />
              )}

              {!!iconTypes.length && (
                <div className="c-TeaserExternal-categories">
                  {iconTypes.map(category => (
                    <DfbIcon icon_type={category} viewBox="0 0 24 24" add_class="c-TeaserExternal-icon c-TeaserExternal-icon--category" />
                  ))}
                </div>
              )}
            </div>
          </div>
        )}

        {(topline || headline || description || link) && (
          <div className="c-TeaserExternal-text">
            {topline && (
              <div className="c-TeaserExternal-topline">{topline}</div>
            )}

            {headline && (
              <div className="c-TeaserExternal-headline">
                <DfbHeadline
                  headline={headline}
                  headline_level="h4"
                />

                {type && !img && (
                  <DfbIcon icon_type={type} add_class="c-TeaserExternal-icon c-TeaserExternal-icon--type" />
                )}
              </div>
            )}

            {description && (
              <DfbParagraph
                text={description}
                add_class="c-TeaserExternal-description"
              />
            )}

            {link_obj.title && (
              <div className="c-TeaserExternal-anchor">
                <DfbAnchor
                  tagName="span"
                  text={link_obj.title}
                />
                <DfbIcon icon_type="arrow-right-up" add_class="c-TeaserExternal-icon c-TeaserExternal-icon--anchor" />
              </div>
            )}
          </div>
        )}
      </a>
    </div>
  )
}

export default CTeaserExternal
